export default "__VITE_ASSET__B162Ksps__"